// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__NygDJ","spinner":"Spinner_spinner__tPt-F","backdrop":"Spinner_backdrop__ZH4Tp"};